import React from 'react';

/**
 * Placeholder navigation bar from the iGEM website to simulate what is being covered up top.
 */
export const DebugHeader: React.FC = () => {
    return <div className="debug-header"></div>;
}